import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";
import { ZSpecification } from "src/business/specification";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { MdmTable, MdmTableSystemTools } from "src/components/MdmTable";
import { RtSearch } from "src/components/ReactiveTable/components/RtSearch";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ManagementSpecCommonListStore } from "./ManagementSpecCommonListStore";
import { ManagSpecActions } from "./ManagSpecActions";

type PropsManagementSpecCommonList = {
  cardUrl: PageUrl;
  pageStore: ManagementSpecCommonListStore;
};

export const ManagementSpecCommonList: React.FC<
  PropsManagementSpecCommonList
> = (props) => {
  const { cardUrl, pageStore } = props;
  const { tableStore } = pageStore;

  return (
    <ToolBox2
      paddingMode="page"
      mainTool={<RtSearch store={pageStore.tableStore} />}
      extraTools={
        <>
          <MdmTableSystemTools store={tableStore} />
          <ManagSpecActions pageStore={pageStore} />
          <Link to={makeUrl(cardUrl, { id: "new" })}>
            <Button type="primary" icon={<PlusCircleOutlined />}>
              Создать
            </Button>
          </Link>
        </>
      }
    >
      <MdmTable
        store={tableStore}
        columns={columns}
        rowClick={{
          type: "link",
          builder: (row) => makeUrl(cardUrl, { id: row.id }),
        }}
      />
    </ToolBox2>
  );
};

const columns: RtColumn<ZSpecification>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    render: (row) => row.name,
  },
  {
    key: "displayName",
    title: "Название",
    render: (row) => row.displayName,
  },
  {
    key: "description",
    title: "Описание",
    render: (row) => row.description,
  },
  {
    key: "attrsCount",
    title: "Количество атрибутов",
    render: (row) => row.definition?.attributes.length ?? 0,
    align: "center",
  },
  ...sysColumnsHistory,
];
